import React from "react";
import { Container } from "react-bootstrap";
import classes from "./TabContainer.module.css";

const TabContainer = (props) => (
  <Container className={classes.container} fluid>{props.children}</Container>
);

export default TabContainer;
